import { Injectable } from '@angular/core'
import { HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { ScheduleLayout, ScheduleSearchPartial } from '@flocasts/experience-service-types'
import { EXPERIENCE_API_SCHEDULE_BASE_PATH, EXPERIENCE_API_VERSION } from '../app.config'
import { CacheDataService } from '../singleton-services/cache-data.service'
import { VerticalService } from '../singleton-services/vertical.service'
import { SiteIds } from '../shared/models/site.model'
import { DataService } from '../data/data.service'

@Injectable()
export class ScheduleDataService {
  constructor(
    private readonly cacheDataService: CacheDataService,
    private readonly verticalService: VerticalService,
    private readonly dataService: DataService
  ) {}

  public getScheduleExperience(
    date?: string,
    search?: string,
    facets?: string,
    isInGeoBlockingExperimentVariation?: boolean
  ): Observable<ScheduleLayout | undefined> {
    return this.verticalService.siteId$.pipe(
      switchMap(siteId => {
        let params = new HttpParams({
          fromObject: {
            version: EXPERIENCE_API_VERSION,
            site_id: siteId || SiteIds.FLODOGS,
            limit: '100',
            offset: '0',
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles',
            showFavoriteIcon: true
          }
        })

        params = isInGeoBlockingExperimentVariation
          ? params.set('enableGeoBlock', isInGeoBlockingExperimentVariation)
          : params
        params = search ? params.set('search', search) : params
        params = facets ? params.set('facets', facets) : params

        const path = date ? `${EXPERIENCE_API_SCHEDULE_BASE_PATH}/${date}` : EXPERIENCE_API_SCHEDULE_BASE_PATH

        return this.cacheDataService.wrapper<ScheduleLayout>(path, params, true)
      })
    )
  }
  public getSchedulePaginatedPartial(endpoint: string): Observable<ScheduleSearchPartial | undefined> {
    return this.dataService.get<ScheduleSearchPartial>(endpoint)
  }
}
